import { render, staticRenderFns } from "./learningDetailsByClass.vue?vue&type=template&id=46d652ae"
import script from "./learningDetailsByClass.vue?vue&type=script&lang=js"
export * from "./learningDetailsByClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports